<template>
    <pendo-alert
        class="ancient-app-version-banner"
        heading-level="2"
        type="warning"
        :title="title">
        {{ $t('ancientAppVersionBanner.Refresh the page to get the latest fixes and features.') }}
        <pendo-button
            type="link"
            @click="refresh">
            {{ $t('ancientAppVersionBanner.Refresh page') }}
        </pendo-button>
    </pendo-alert>
</template>
<script>
import {
    PendoAlert,
    PendoButton,
} from '@pendo/components-vue3';

export default {
    name: 'AncientAppVersionBanner',
    components: {
        PendoAlert,
        PendoButton,
    },
    props: {
        daysOutOfDate: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        title () {
            return this.$t('ancientAppVersionBanner.You haven\'t refreshed in {daysOutOfDate} days', { daysOutOfDate: this.daysOutOfDate });
        },
    },
    methods: {
        refresh () {
            window.location.reload();
        },
    },
};
</script>
<style lang="less">
.ancient-app-version-banner {
    min-height: 60px;
    height: 60px;
    border-radius: 0px;

    .pendo-alert__description {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .pendo-button--link {
        line-height: unset;
        height: unset;
    }
}
</style>